var cardProductSeeMoreBtns = document.querySelectorAll("[data-card-product-see-more]");
var cardProductSeeLessBtns = document.querySelectorAll("[data-card-product-see-less]");
var cardProductTexts = document.querySelectorAll("[data-card-product-see-more-text]");
var featuredProductsSwiper = document.querySelector('.featured-products .swiper');
var featuredProductsTitle = document.querySelector('.featured-products__subtitle-product');

function updateSwiperHeight() {
    if (featuredProductsSwiper && featuredProductsSwiper.swiper) {
        featuredProductsSwiper.swiper.updateAutoHeight();
    }
}

function extractFirstColorFromGradient(gradient) {
    // Trouver la première couleur dans le gradient (rgba ou rgb)
    const match = gradient.match(/(?:rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\))/);
    if (match) {
        return `rgb(${match[1]}, ${match[2]}, ${match[3]})`;
    }
    return null;
}

function updateTitleColor() {
    if (featuredProductsSwiper && featuredProductsSwiper.swiper) {
        const activeSlide = featuredProductsSwiper.swiper.slides[featuredProductsSwiper.swiper.activeIndex];
        console.log("activeSlide", activeSlide);
        const gradient = activeSlide.getAttribute('data-featured-product-background-gradient');
        if (gradient && featuredProductsTitle) {
            const firstColor = extractFirstColorFromGradient(gradient);
            if (firstColor) {
                featuredProductsTitle.style.color = firstColor;
            }
        }
    }
}

function toggleAllCards(show) {
    cardProductTexts.forEach((text, index) => {
        if (show) {
            text.style.maxHeight = text.scrollHeight + 'px';
            cardProductSeeMoreBtns[index].style.display = 'none';
            cardProductSeeLessBtns[index].style.display = 'flex';
        } else {
            text.style.maxHeight = null;
            cardProductSeeMoreBtns[index].style.display = 'flex';
            cardProductSeeLessBtns[index].style.display = 'none';
        }
    });

    // Mettre à jour la hauteur toutes les 100ms pendant 500ms
    let interval = setInterval(updateSwiperHeight, 100);
    setTimeout(() => clearInterval(interval), 500);
}

// Initialiser la couleur du titre
window.addEventListener('load', function () {
    updateTitleColor();
    // Mettre à jour la couleur du titre à chaque changement de slide
    if (featuredProductsSwiper && featuredProductsSwiper.swiper) {
        featuredProductsSwiper.swiper.on('slideChange', updateTitleColor);
    }
});


cardProductSeeMoreBtns.forEach((buttonMore, index) => {
    buttonMore.addEventListener('click', () => {
        toggleAllCards(true);
    });
});

cardProductSeeLessBtns.forEach((buttonLess, index) => {
    buttonLess.addEventListener('click', () => {
        toggleAllCards(false);
    });
});

/** Smooth scroll - Version CSS pure (légère) **/
// Le CSS gère le smooth scroll via scroll-behavior: smooth
// On a juste besoin d'empêcher le thème Impact d'intercepter les clics sur les liens avec hash

document.addEventListener('click', function(e) {
    const target = e.target.closest('a[href*="#"]');
    if (!target) return;
    
    const href = target.getAttribute('href');
    if (!href || href === '#') return;
    
    // Extraire le hash
    let hash;
    if (href.startsWith('#')) {
        hash = href;
    } else {
        const url = new URL(href, window.location.href);
        // Vérifier si c'est la même page
        if (url.pathname !== window.location.pathname) return;
        hash = url.hash;
    }
    
    if (!hash) return;
    
    // Trouver l'élément cible
    const element = document.querySelector(hash);
    
    if (element) {
        // Le CSS scroll-behavior: smooth s'occupera de l'animation
        // On a juste besoin de laisser le navigateur faire son travail
        // Pas besoin de preventDefault car on veut le comportement natif
    }
}, false);

// Card Review - Toggle "voir plus/moins"
document.addEventListener('DOMContentLoaded', function() {
    function initReviewToggle() {
        const wrappers = document.querySelectorAll('.card-review__description-wrapper');
        
        wrappers.forEach(wrapper => {
            const description = wrapper.querySelector('.card-review__description');
            const toggleBtn = wrapper.querySelector('.card-review__toggle-btn');
            
            if (!description || !toggleBtn) return;
            
            // Vérifier si le contenu dépasse 130px
            if (description.scrollHeight > 130) {
                wrapper.classList.add('has-overflow');
            }
            
            // Gérer le clic sur le bouton
            toggleBtn.addEventListener('click', function(e) {
                e.preventDefault();
                wrapper.classList.toggle('is-expanded');
            });
        });
    }
    
    // Initialiser au chargement
    initReviewToggle();
    
    // Réinitialiser si Swiper charge de nouvelles slides
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                initReviewToggle();
            }
        });
    });
    
    // Observer les changements dans les conteneurs de reviews
    const reviewContainers = document.querySelectorAll('.section-reviews, .swiper-wrapper');
    reviewContainers.forEach(container => {
        observer.observe(container, { childList: true, subtree: true });
    });
});